import { EventEmitter } from "events";
import Dispatcher from "../Dispatcher";
import actionTypes from "../actions/ActionTypes";
const CHANGE_EVENT = "isChange";
let _lastChange = "";
let _currentReader = void 0;
let _currentReaderMap = void 0;
let _readers = void 0;
let _readerMaps = [];
let _readerFormTypes = [];
class ReadersStore extends EventEmitter {
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  getReaders() {
    return _readers;
  }
  getReaderMaps() {
    return _readerMaps;
  }
  getReader() {
    return _currentReader;
  }
  getReaderMap() {
    return _currentReaderMap;
  }
  getLastAction() {
    return _lastChange;
  }
  getReaderFormTypes() {
    return _readerFormTypes;
  }
}
const store = new ReadersStore();
Dispatcher.register((action) => {
  _lastChange = action.actionType;
  switch (action.actionType) {
    case actionTypes.GetReaders:
      _readers = action.Result;
      store.emitChange();
      break;
    case actionTypes.ReaderMapLoad:
      _readerMaps = action.Result;
      store.emitChange();
      break;
    case actionTypes.GetReader:
      _currentReader = action.Result;
      store.emitChange();
      break;
    case actionTypes.ReaderMapGet:
      _currentReaderMap = action.Result;
      store.emitChange();
      break;
    case actionTypes.ReaderUpdate:
      _currentReader = action.Result;
      let instance = _readers.find((f) => f.readerId === _currentReader.readerDBId);
      if (instance === void 0) {
        _readers.push({
          readerId: action.Result.readerDBId,
          name: action.Result.readerName
        });
      } else {
        instance.name = action.Result.readerName;
      }
      store.emitChange();
      break;
    case actionTypes.ReaderMapUpdate:
      _currentReaderMap = action.Result;
      let instance3 = _readerMaps.find((f) => f.readerMapId === _currentReaderMap.readerMapId);
      if (instance3 === void 0) {
        console.log("push");
        _readerMaps.push({
          readerMapId: action.Result.readerMapId,
          readerId: action.Result.readerId,
          readerName: action.Result.readerName,
          formTypeId: action.Result.formTypeId,
          formTypeName: action.Result.formTypeName
        });
        console.log(_readerMaps);
      } else {
      }
      store.emitChange();
      break;
    case actionTypes.ReaderDelete:
      let reader = action.Result;
      let instance2 = _readers.find((f) => f.readerId === reader.readerDBId);
      if (instance2 !== void 0) {
        let didx = _readers.indexOf(instance2);
        _readers.splice(didx, 1);
      }
      store.emitChange();
      break;
    case actionTypes.ReaderMapDelete:
      let map = action.Result;
      console.log(map);
      console.log(_readerMaps);
      let mapInstance = _readerMaps.find((f) => f.readerMapId === map.readerMapId);
      if (mapInstance !== void 0) {
        let didx = _readerMaps.indexOf(mapInstance);
        _readerMaps.splice(didx, 1);
      }
      store.emitChange();
      break;
    case actionTypes.ReadersFormTypes:
      let rft = action.Result;
      _readerFormTypes = rft;
      store.emitChange();
      break;
    default:
  }
});
export default store;
